import { useState, useEffect } from 'react';
import { Modal, Label } from 'flowbite-react';
import ReactSelect from 'react-select';
import { getPartnersFiltered } from '../../../common/services/partners.api';

type PartnerSelectModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSelectPartner: (partners: { value: string; label: string }[] | null) => void;
  selectedPartner: { value: string; label: string }[] | null;
}

export function PartnerSelectModal({ isOpen, onClose, onSelectPartner, selectedPartner }: PartnerSelectModalProps) {
  const [partnerOptions, setPartnerOptions] = useState<{ value: string; label: string }[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, ] = useState('');
  const [tempSelectedPartner, setTempSelectedPartner] = useState<{ value: string; label: string }[] | null>(selectedPartner);

  useEffect(() => {
    setTempSelectedPartner(selectedPartner);
  }, [selectedPartner]);

  useEffect(() => {
    async function loadPartners() {
      if (isOpen) {
        setIsLoading(true);
        try {
          const result = await getPartnersFiltered();
          if (result.ok) {
            const partners = result.data.map((partner) => ({
              value: partner._id || "",
              label: partner.companyName,
            }));
            setPartnerOptions(partners);
          }
        } catch (error) {
          console.error('Erro ao carregar parceiros:', error);
        } finally {
          setIsLoading(false);
        }
      }
    }

    loadPartners();
  }, [isOpen]);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handlePartnerChange = (options: any) => {
    setTempSelectedPartner(options || null);
  };

  return (
    <Modal
      size="7xl"
      show={isOpen}
      onClose={onClose}
      style={{
        minHeight: '25em'
      }}
    >
      <Modal.Header>
        <h2 className="text-lg font-semibold text-black">Selecionar Parceiro</h2>
      </Modal.Header>
      <Modal.Body
        style={{ minHeight: '20em' }}
      >
        <div className="space-y-4">
          <div>
            <Label htmlFor="selectPartner" className="block mb-1 font-medium bg">Parceiros:</Label>
            <ReactSelect
              options={partnerOptions.filter(partner =>
                searchTerm ? partner.label.toLowerCase().includes(searchTerm.toLowerCase()) : true
              )}
              name="selectedPartner"
              onChange={handlePartnerChange}
              placeholder={isLoading ? "Carregando parceiros..." : "Selecione um ou mais parceiros"}
              isLoading={isLoading}
              value={tempSelectedPartner}
              className="w-full"
              classNamePrefix="react-select"
              isClearable
              isMulti
              styles={{
                control: (provided) => ({
                  ...provided,
                  color: 'black',
                  backgroundColor: 'white',
                  borderColor: provided.borderColor,
                }),
                singleValue: (provided) => ({
                  ...provided,
                  color: 'black',
                }),
                input: (provided) => ({
                  ...provided,
                  color: 'black',
                }),
                placeholder: (provided) => ({
                  ...provided,
                  color: 'black',
                }),
                menu: (provided) => ({
                  ...provided,
                  color: 'black',
                  backgroundColor: 'white',
                }),
                option: (provided, state) => ({
                  ...provided,
                  color: 'black',
                  backgroundColor: state.isFocused ? '#f3f4f6' : 'white',
                }),
              }}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="flex justify-end space-x-2">
        <button
          className="filter-generic-button"
          onClick={() => {
            onClose();
            onSelectPartner([]);
          }}
        >
          Limpar filtros
        </button>
        <button
          className="filter-generic-button"
          onClick={() => {
            onClose();
            onSelectPartner(tempSelectedPartner);
          }}
          disabled={!tempSelectedPartner || tempSelectedPartner.length === 0}
        >
          Aplicar filtros
        </button>
      </Modal.Footer>
    </Modal>
  );
}